export const Stipends = ({ className }: { className?: string }) => {
  return (
    <svg
      fill="none"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="m16 5-9 4v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12v-6zm3.08 15-3.08-1.85-3.07 1.85.81-3.5-2.71-2.34 3.58-.31 1.39-3.3 1.39 3.29 3.58.31-2.71 2.35z"
        fill="currentColor"
      />
    </svg>
  );
};
